import React, { useEffect, useState } from "react";

import "./homestyle.css";
import TickArrow from "../../assets/images/tickarrow.png";
import { useChatContext } from "../../context/ChatContext";

// import { sendMessage, decodeToken } from
const ContentInner1 = () => {
  
  const [message, setMessage] = useState("");
  const [grade] = useState("10th Grade");
  const [visibleMsgBox, setVisibleMsgBox] = useState(false);
  const { setInitialStart } = useChatContext();
  const token = localStorage.getItem("access_token");

  const handleSend = () => {
    // alert("Hi")
    if(visibleMsgBox){
    if (message.trim()) {
      if(token){
        setInitialStart(visibleMsgBox);
      }
    
    // getAllmessage(message);
    setMessage("");
  }
 }
// } else {
//   alert("please select atleast one option");
// }

  };

  useEffect(() => {
    setMessage(grade);
  }, [grade]);
  useEffect(() => {
    handleSend();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [visibleMsgBox]);

  return (
    <>
    

         
          <div className="home-inner-page content" id="content">
           <div className="homme-outer-container">
            <div className="hoome-inner-outer">
           <div className="lorem-inner">
          <h2>SCSBC CHATBOT </h2>
          <div className="scsbc-chartboart">
          <div className="row start-flex">
            {/* <div className="col-lg-3 "></div> */}
            <h5 className="mb-3">Hi there! Let’s plan something amazing.</h5>
            <p>Would you like to create a Unit Plan, a Lesson Plan, or get Learning Support today?</p>
            <div className="twice-btn" >
             
               <button onClick={() => setVisibleMsgBox("UnitPlanning")} className="btn">Unit Plans</button>
               <button onClick={() => setVisibleMsgBox("LessonPlanning")} className="btn">Lesson Plans </button>
               {/* <img src={TickArrow}/> */}
               {/* {visibleMsgBox=="UnitPlanning"?<img src={TickArrow}/>:""} */}
               {/* <div className={`unit-plan ${visibleMsgBox === "UnitPlanning" ? "green-box" : ""}`}></div> */}
            </div>

            {/* <div className="col-lg-6 col-md-6 col-sm-12" 
              //onClick={(e) => setVisibleMsgBox("LessonPlanning")}
              
              > */}
            {/* <div  className={`unit-plan ${visibleMsgBox === "LessonPlanning" ? "green-box" : ""}`}>
            <h3>Lesson Plans</h3>
            {visibleMsgBox=="LessonPlanning"?<img src={TickArrow}/>:""}

           </div> */}
            {/* </div> */}

                 {/* <div className="col-lg-3"></div>
                 <div className="col-lg-3"></div> */}

                    {/* <div className="col-lg-3 col-md-6 col-sm-12" onClick={(e) => setVisibleMsgBox("Assignments")}>
                    <div  className={`unit-plan ${visibleMsgBox === "Assignments" ? "green-box" : ""}`}>
                    <h3>Assignment(s)</h3>
                    {visibleMsgBox=="Assignments"?<img src={TickArrow}/>:""}
                    </div>

                      </div> */}
                    
                    <div className="col-lg-12 col-md-6 col-sm-12"
                     onClick={(e) => setVisibleMsgBox("LearningSupports")}
                    // onClick={handleLockedClick} 

                    >
                     <div style={{display: "inline-block", cursor: "pointer"}}  className={`unit-plan ${visibleMsgBox === "LearningSupports" ? "green-box" : ""}`}>
                    <h3> Learning Support </h3>
                    {visibleMsgBox === "LearningSupports" ? <img src={TickArrow} alt="" /> : ""}
                    </div> 

                    </div>
                  
                      {/* <div className="col-lg-3 col-md-6 col-sm-12" onClick={(e) => setVisibleMsgBox("Assessment")} >
                      <div  className={`unit-plan ${visibleMsgBox === "Assessment" ? "green-box" : ""}`}>
                      <h3>Assessment(s) </h3>
                      {visibleMsgBox=="Assessment"?<img src={TickArrow}/>:""}
                    </div>
                      </div> */}

                   <div className="col-lg-3"></div>
          </div>
          </div>
        {/* <div className="button-next" onClick={handleSend}>
            <button 
            style={visibleMsgBox ? { backgroundColor: "rgba(44, 104, 161, 1)" } : {}}
            >
              Next
            <i className="fa fa-arrow-circle-right" aria-hidden="true"/></button>
        </div> */}

        </div>
           </div>
          </div>
        </div>
    </>
  );
};

export default ContentInner1;
